<template>
  <div>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item has-feedback label="Title / Tiêu đề" prop="name">
        <a-input v-model="form.name" placeholder="Enter title" />
      </a-form-model-item>
      <a-form-model-item
        has-feedback
        label="Main Shift / Ca làm việc chính"
        prop="mainShiftId"
      >
        <SelectWorkShift
          v-model="form.mainShiftId"
          :initial-datas="form.mainShift ? [form.mainShift] : null"
          :select-props="{
            placeholder: 'Choose shift',
            value: form.mainShiftId,
          }"
          :variables-query="{
            isOvertime: false,
          }"
        />
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button @click="closeDrawerAdd" style="margin-right: 5px;" icon="close">
        Close
      </a-button>
      <a-button
        type="primary"
        @click="create()"
        :loading="iconLoading"
        icon="plus"
      >
        Create
      </a-button>
    </div>
  </div>
</template>
<script>
import queryItem from "../data/queryItem";
//components
import SelectWorkShift from "@/components/common/workShift/select";

export default {
  components: { SelectWorkShift },
  props: {
    closeDrawerAdd: {
      type: Function,
      default: null,
    },
    createdOnView: {
      type: Function,
    },
  },
  data() {
    return {
      iconLoading: false,
      form: {
        name: undefined,
        userIds: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "Required / Tên không được bỏ trống",
            trigger: "change",
          },
          {
            min: 3,
            max: 255,
            message: "Length should be 3 to 255",
            trigger: "change",
          },
        ],
        mainShiftId: [
          {
            required: true,
            message: "Required / Tên không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    create() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          console.log(this.form);
          this.$apollo
            .mutate({
              mutation: queryItem.queryCreate,
              variables: {
                ...this.form,
                mainShiftId: this.form.mainShiftId || null,
              },
            })
            .then(({ data }) => {
              if (data?.createBranchLocation) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });
                this.closeDrawerAdd();
                this.createdOnView(data.createBranchLocation);
              }
              this.iconLoading = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              this.iconLoading = false;
            });
        }
      });
    },
  },
};
</script>
<style></style>
